/*
* Copyright (C) Regione Lombardia
*/
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { UtenteService } from '@shared/services/utente.service';
import { UtilsService } from '@shared/services/utils.service';
import { of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable()
export class CoreHttpInterceptor implements HttpInterceptor {

    private cache = new Map<string, any>();
    private pendingRequests = new Map<string, any>();

    constructor(
        private utilsService: UtilsService,
        private router: Router,
        private utenteService: UtenteService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler) {
        const projectCache = request.headers.get('projectCache');
        if (projectCache === '1') {
            const cachedResponse = this.cache.get(request.url);
            if (cachedResponse) {
                return of(cachedResponse);
            }
            request.headers.delete('projectCache');
        }
        this.utilsService.inLoading(true);
        this.pendingRequests.set(request.url, request);
        return next.handle(request).pipe(
            finalize(() => {
                this.pendingRequests.delete(request.url);
                if (this.pendingRequests.size === 0) {
                    this.utilsService.inLoading(false);
                }
            }),
            map((event: HttpEvent<any>) => {
                if (!(event instanceof HttpResponse) || !event.body) {
                    return event;
                }
                if (projectCache === '1') {
                    this.cache.set(request.url, event);
                }
                return event;
            }),
            catchError(response => {
                this.utilsService.inLoading(false);
                if (response.status == 200 && response.ok == false) {
                    const errorObj: string = response.error.text.toString().toLowerCase();
                    if (errorObj.includes('<html>') && (errorObj.includes('shibboleth authentication request') || errorObj.includes('verifica identificazione elettronica in corso') || errorObj.includes('verifica autenticazione in corso') ) ) {
                        this.utenteService.logged = false;
                        this.router.navigate(['/home']);
                    }
                } else if(response.status === 403) {
                    this.router.navigate(['/home']);

                }
                else {
                    this.utilsService.showError(response.error.message || CoreI18nConfigs.messages.genericError);
                }
                throw response;
            })
        );
    }

}
